import { Accordion } from "@ruter-as/web-components-and-tools";
import "./Faq.scss";

const Faq: React.FC = () => {
	return (
		<Accordion className="components-wrapper-faq">
			<Accordion.Item title="Hvorfor kan jeg ikke bestille en billett fra og med i dag?">
				<p>
					Billetten er en del av Ruters bedriftstilbud og følger derfor
					kalendermåned for å forenkle administrasjon av tjenesten.
				</p>
			</Accordion.Item>
			<Accordion.Item title="Jeg har allerede en gyldig periodebillett, kan jeg refundere denne? ">
				<ul>
					<li>
						Åpne Ruter-appen, klikk følgende: Billetter → Billettdetaljer → Vis
						kvittering.{" "}
					</li>
					<li>
						Kontroller at du er inne på riktig periodebillett, og hent ut
						billettnummer (ti siffer){" "}
					</li>
					<li>
						Send billettnummer i epost til refusjon@ruter.no. Skriv «refusjon
						prøveprosjekt» i emnefeltet.{" "}
					</li>
					<li>
						Ruter refunderer overlappende periode. Gammel billett blir ugyldig
						når ny billett trer i kraft. Denne typen refusjoner behandles én
						gang i måneden, i forbindelse med månedsskifte, så noe
						behandlingstid må påregnes.
					</li>
				</ul>
			</Accordion.Item>
			<Accordion.Item title="Hvordan får jeg billetten?">
				<ul>
					<li>
						Hvis det står "Bestill bedriftsbillett" øverst i bestillingsskjemaet
						vil du motta en SMS med link til billetten din når du har sendt inn
						bestillingen.
					</li>
					<li>
						Hvis det står "Søk om bedriftsbillett" øverst i bestillingsskjemaet
						blir det sendt en henvendelse til administrator i din bedrift/ditt
						borettslag. Når bestillingen er godkjent av administrator vil du
						motta en SMS med lenke til din billett.
					</li>
					<li>
						For å hente billetten må du ha Ruter-appen og være innlogget med
						Ruter profil, med samme telefonnummer som billetten er registrert
						på.
					</li>
					<li>
						Når du mottar SMS med hentekode, trykker du på lenken og får den opp
						i Ruter-appen. Alternativt kan du også taste inn hentekoden manuelt
						i appen.
					</li>
				</ul>
			</Accordion.Item>
			<Accordion.Item title="Hvor finner jeg min billett?">
				<p>
					Når du har logget inn i Ruter-appen og hentet billetten, vil den ligge
					i Ruter-appen som andre billetter.
				</p>
			</Accordion.Item>
			<Accordion.Item title="Hvordan fungerer billetten?">
				<ul>
					<li>Billetten fungerer som en ordinær periodebillett fra Ruter </li>
					<li>
						Billetten kan brukes på Ruters busser, trikker, T-baner og båter, og
						på Vys tog for de sonene du har valgt.{" "}
						<a
							href="https://ruter.no/om-vare-billetter/soner-og-sonekart"
							target="_blank"
							rel="noreferrer"
						>
							Se sonekart her.
						</a>
					</li>
				</ul>
			</Accordion.Item>
			<Accordion.Item title="Hvordan flytte billetten til en ny telefon?">
				<ul>
					<li>
						Logg inn i Ruter appen med samme telefonnummer på ny telefon. Trykk
						inn på billetten som står som ikke gyldig på denne enheten. Du får
						da valget om å flytte billetten.{" "}
					</li>
					<li>Det er mulig å overføre billetten 10 ganger totalt</li>
				</ul>
			</Accordion.Item>

			<Accordion.Item title="Hvor finner jeg rabattkoden for leiebil?">
				<p>
					Du må velge en aktør for å få koden din. I det du henter ut koden vil
					oppspart rabatt nullstilles.
				</p>
			</Accordion.Item>
			<Accordion.Item title="Hva skjer med leiebilsrabatten min når jeg sier opp abonnementet?">
				<p>
					Du vil ikke lenger kunne hente ut rabattkode dersom du har sagt opp
					abonnementet. Vi anbefaler derfor at du henter ut oppspart rabatt før
					du ev. avslutter, men vi vil selvsagt helst at du blir hos oss.
				</p>
			</Accordion.Item>
			<Accordion.Item title="Hva er inkludert i leiebilstjenesten?">
				<p>
					Dette er litt varierende mellom aktører og avhenger også av om du
					leier en elbil som står ved en ladestolpe eller en fossilbil. Se de
					forskjellige aktørenes vilkår her:{" "}
					<a
						target="_blank"
						rel="noreferrer"
						href="https://www.hyre.no/vilk%C3%A5r/"
					>
						Hyre
					</a>
					,{" "}
					<a
						target="_blank"
						rel="noreferrer"
						href="https://www.bilkollektivet.no/vilkar"
					>
						Bilkollektivet
					</a>{" "}
					og{" "}
					<a
						target="_blank"
						rel="noreferrer"
						href="https://no.getaround.com/terms"
					>
						Getaround
					</a>
				</p>
			</Accordion.Item>
			<Accordion.Item title="Hva skjer når jeg allerede har 600 kr i oppspart rabatt og en ny måned har gått?">
				<p>Du vil få en ny lenke på SMS. Rabatten vil fortsatt være 600 kr.</p>
			</Accordion.Item>
		</Accordion>
	);
};

export default Faq;
